import "./App.css";
import AccessoItalianoApp from "./main/AccessoItaliano";
import BackgroundComponent from "./main/components/core/background-component/BackgroundComponent";
import FooterComponent from "./main/components/core/footer-component/FooterComponent";
import HeaderComponent from "./main/components/core/header-component/HeaderComponent";
import { BrowserRouter, useLocation } from "react-router-dom";

function AppContent() {
  const navLinks = ["login", "contatti", "docs"];
  const location = useLocation();
  const excludedPaths = ["/dashboard", "/dashboard/invoices","/dashboard/inventory","/dashboard/settings"];
  const showHeader = !excludedPaths.includes(location.pathname);

  return (
    <div className="App">
      <BackgroundComponent />
      {showHeader && <HeaderComponent items={navLinks} />}
      <div className="app-content">
        <AccessoItalianoApp />
      </div>
      <FooterComponent />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
